angular.module("Main").controller("NoAccessOnlineSalesController", ["$stateParams", "BookingService", "SessionService",
    function ($stateParams, BookingService, SessionService) {
        var vm = this;

        if (!SessionService.getSessionId()) {
            BookingService.loadClublink().then(function (config) {
                vm.clubUrl = config.link;
            })
        } else {
            BookingService.loadClublink().then(function (config) {
                vm.clubUrl = config.link;
            })
        }
    }]);
